import { render, staticRenderFns } from "./statement-list.vue?vue&type=template&id=0930d90e&scoped=true"
import script from "./statement-list.vue?vue&type=script&lang=js"
export * from "./statement-list.vue?vue&type=script&lang=js"
import style0 from "./statement-list.vue?vue&type=style&index=0&id=0930d90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0930d90e",
  null
  
)

export default component.exports